import { createFetchAndCacheAtom } from '@mostrans/web-components/helpers/atomHelpers';


export const MasterDivisiAtom = createFetchAndCacheAtom([])